import React, {Component} from "react"

import AppContainer from "@irati/ui/src/AppContainer"
import authentication from "@irati/auth"
import {LangLoader} from "@irati/utils/lang"
import {NestedRoute, PartialRoute, withPartialRoute} from "@irati/utils/history/routing"
import {PERKS} from "@irati-web/app/src/routeConfig"

import CultureHub from "../containers/CultureHub"
import EditCultureHub from "../containers/EditCultureHub"

interface Props {
  path: string
}

class HomeRoutes extends Component<Props> {
  render() {
    if (!authentication.isLoggedIn()) {
      // protect against unauthed
      return null
    }
    const {path} = this.props

    return (
      <LangLoader bucket={PERKS}>
        <AppContainer>
          <NestedRoute exact path="/home" component={CultureHub} useGrid={false} />
          <PartialRoute permissions="admin" match={path} path="/edit" component={EditCultureHub} title="Edit Culture Hub" />
        </AppContainer>
      </LangLoader>
    )
  }
}

export default withPartialRoute(HomeRoutes)
